import React from "react";
import { Box, Icon, Typography } from "@material-ui/core";

const ProfileInfo = ({ patient, classes }) => {
  return (
    <>
      <Typography className={classes.name}>
        {patient.firstName} {patient.lastName}
      </Typography>

      {patient.position && (
        <Box className={classes.userProfileRoleContainer}>
          <Icon className={classes.userProfileRoleIcon}>
            radio_button_unchecked
          </Icon>
          <Typography classes={{ root: classes.userProfileRole }}>
            {patient.position}
          </Typography>
        </Box>
      )}

      <Box className={classes.jursyNumberContainer}>
        {patient.mrn && (
          <Typography className={classes.jursyNumberLabel}>
            Medical Record Number: #{patient.mrn}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ProfileInfo;
